export default {
  'kid-list:title': 'Для кого вы оформляете карту?',
  'kid-list:title-noAcceptable': 'Kaspi Gold для ребенка можно оформить только для своих детей от 6 до 16 лет',
  'kid-list:age': 'лет',
  'kid-list:tip-1': 'Можно открыть только с 6 лет',
  'kid-list:tip-2': 'Уже есть Kaspi Gold для ребенка',
  'kid-list:tip-3': 'Может самостоятельно открыть Kaspi Gold',
  'kid-list:btn-to-main': 'Вернуться на Главную Kaspi.kz',
  'kid-list:guide-title': 'Ответы на частые вопросы'
}
